module.exports = __webpack_public_path__ + "img/logoshop.55c0309e.png";